import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector   : 'wor-import-equation',
  template: require('./import.equation.component.html')
})
export class ImportEquationComponent implements OnChanges {
  @Input() match: any;

  _model: any;

  @Input() set model ( _model : any ) {
    this._model = _model;
  };

  @Output() modelChange: EventEmitter<any> = new EventEmitter();

  equation: Array<any> = [];

  buildEquation () : Array<any> {
    const params: Array<any> = [];

    const equation = this.match.equation;

    if ( !equation ) {
      return params;
    }

    const paramsRegex = /\{\s*(param\d+)\s*\}/gi;

    let last       = 0;
    let paramIndex = 0;

    let match: RegExpExecArray | null;

    while( match = paramsRegex.exec(equation) ) {
      const value = equation.slice(last, match.index).trim();

      if ( value ) {
        params.push({
          index   : paramIndex,
          isString: true,
          value   : value
        });
      }

      params.push({
        index   : paramIndex,
        isString: false,
        value   : match[ 1 ]
      });

      last = paramsRegex.lastIndex;

      paramIndex++;
    }

    const tail = equation.slice(last).trim();

    if ( tail ) {
      params.push({
        index   : paramIndex,
        isString: true,
        value   : tail
      });
    }

    return params;
  }

  ngOnChanges ( changes : SimpleChanges ) : void {
    this.equation = this.buildEquation();
  }
}
